<template>
  <el-table
    :data="getTableData"
    border
    style="width: 100%"
    :maxHeight="maxHeight"
    :span-method="objectSpanMethod"
  >
    <template slot="empty">
      <empty />
    </template>
    <el-table-column
      prop="type"
      :label="currentPath == 'THEME_TYPE_SALES' ? '下单来源' : '流量来源'"
      width="120"
      align="center"
    >
      <template slot-scope="{ row }">
        <span>
          {{
            currentPath == "THEME_TYPE_SALES"
              ? row.themeTypeName
              : row.cBizTypeName
          }}</span
        >
      </template>
    </el-table-column>
    <el-table-column prop="dateRange" label="时间" width="190" align="center" />
    <el-table-column
      v-for="item in tableColumnList"
      :key="item.prop"
      :prop="item.prop"
      :label="item.label"
      :min-width="item.minWidth ? item.minWidth : '120'"
      align="center"
    >
      <template slot-scope="{ row }">
        <div
          style="
            display: flex;
            justify-content: center;
            flex-direction: column;
            align-items: center;
            line-height: 27px;
          "
          v-if="
            ['同比', '环比'].includes(row.dateRange) && row[item.prop] !== '-'
          "
        >
          <div>{{ row[item.prop] }}</div>
          <div style="display: flex; align-items: center">
            <span>{{ row[item.prop + "rete"] }}</span>
            <img
              width="20"
              height="20"
              src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/bi/down.svg"
              alt=""
              v-if="parseFloat(row[item.prop + 'rete']) < 0"
            />
            <img
              width="20"
              height="20"
              src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/bi/up.svg"
              alt=""
              v-else
            />
          </div>
        </div>
        <span v-else>{{ row[item.prop] }}</span>
      </template>
    </el-table-column>
    <el-table-column
      v-if="reportParams.measureUnitId"
      prop="measureUnitSum"
      :label="reportParams.measureUnitName + '数'"
      width="120"
      align="center"
    >
      <template slot-scope="{ row }">
        <div
          style="
            display: flex;
            justify-content: center;
            flex-direction: column;
            align-items: center;
            line-height: 27px;
          "
          v-if="
            ['同比', '环比'].includes(row.dateRange) &&
            row.measureUnitSum !== '-'
          ">
          <div>{{ row.measureUnitSum }}</div>
          <div style="display: flex; align-items: center">
            <div>
              {{ row.measureUnitSumrete }}
            </div>
            <img
              width="20"
              height="20"
              src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/bi/down.svg"
              alt=""
              v-if="parseFloat(row.measureUnitSumrete) < 0" />
            <img
              width="20"
              height="20"
              src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/bi/up.svg"
              alt=""
              v-else />
          </div>
        </div>
        <span v-else>{{ row.measureUnitSum }}</span>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import Empty from "../../../components/empty.vue";
import mixins from "../../../mixins/index.js";
export default {
  mixins: [mixins],
  components: {
    Empty,
  },
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    maxHeight: {
      type: [Number, String],
      default: 500,
    },
    currentPath: {
      type: String,
      default: "",
    },
    reportParams: {
      type: Object,
      default: () => {},
    }
  },
  data() {
    return {
      tableColumnList: [
        {
          prop: "saleAmount",
          label: "成交金额",
          align: "right",
        },
        {
          prop: "amountRatio",
          label: "金额占比",
          align: "right",
        },
        {
          prop: "buyerCount",
          label: "成交人数",
          align: "right",
        },
        {
          prop: "buyerRatio",
          label: "人数占比",
          align: "right",
        },
        {
          prop: "orderCount",
          label: "成交单量",
          align: "right",
        },
        {
          prop: "itemCount",
          label: "成交件数",
          align: "right",
        },
        {
          prop: "customerUnitPrice",
          label: "客单价",
          align: "right",
        },
        {
          prop: "orderUnitPrice",
          label: "笔单价",
          align: "right",
        },
        {
          prop: "itemUnitPrice",
          label: "件单价",
          align: "right",
        },
        {
          prop: "avgPurchaseFrequency",
          label: "人均购买频次",
          minWidth: 180,
          align: "right",
        },
        {
          prop: "avgPurchaseItems",
          label: "人均购买件数",
          minWidth: 180,
          align: "right",
        },
        {
          prop: "avgItemsPerOrder",
          label: "笔均购买件数",
          minWidth: 180,
          align: "right",
        },
      ],
    };
  },
  computed: {
    getTableData() {
      let list = this.tableData.map((item) => {
        if (["同比比率", "环比比率"].includes(item.dateRange)) {
          item.buyerCount = +item.buyerCountStr;
          item.orderCount = +item.orderCountStr;
          item.itemCount = +item.itemCountStr;
        }
        return item;
      });
      const tableArr = list.map((row) => {
        const newRow = {};
        Object.keys(row).forEach((key) => {
          if (["同比比率", "环比比率"].includes(row.dateRange)) {
            if (key === "cusTypeName" || key === "dateRange") {
              newRow[key] = row[key];
              return;
            } else {
              newRow[key] = this.formatPercent(row[key]);
            }
          } else {
            // 不需要处理得字段直接返回
            if (
              key === "cusTypeName" ||
              key === "dateRange" ||
              key === "themeTypeName" ||
              key === "cBizTypeName"
            ) {
              newRow[key] = row[key];
              return;
            }
            // Ratio 字段 → 百分比
            if (key.includes("Ratio")) {
              newRow[key] = this.formatPercent(row[key]);
            } else {
              // 其他数值 → 普通数字
              newRow[key] = this.formatNumber(row[key]);
            }
          }
        });
        return newRow;
      });
      const dataList = [];
      tableArr.forEach((item, index) => {
        if (
          item.dateRange.indexOf("同比") == -1 &&
          item.dateRange.indexOf("环比") == -1
        ) {
          dataList.push(item);
        }
        if (item.dateRange === "同比" || item.dateRange === "环比") {
          const keyList = Object.keys(tableArr[index + 1]);
          const newRow = {};
          keyList.forEach((key) => {
            newRow[key + "rete"] = tableArr[index + 1][key];
          });
          dataList.push({
            ...item,
            ...newRow,
          });
        }
      });
      return dataList;
    },
  },
  methods: {
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (rowIndex % 3 === 0) {
          return {
            rowspan: 3,
            colspan: 1,
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
    },
  },
};
</script>
